import { useState, useCallback, useEffect } from 'react';
import { appointmentService, Appointment } from '../services/appointmentService';
import { useAuthStore } from '../stores/authStore';

export const useAppointments = () => {
  const isMatched = useAuthStore((s) => s.isMatched);
  const [appointments, setAppointments] = useState<Appointment[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadAppointments = useCallback(async () => {
    if (!isMatched) return;
    setIsLoading(true);
    setError(null);
    try {
      const data = await appointmentService.getAppointments();
      setAppointments(data.appointments || []);
    } catch (err: any) {
      setError(err.response?.data?.message || err.message || 'Ошибка загрузки записей');
    } finally {
      setIsLoading(false);
    }
  }, [isMatched]);

  useEffect(() => {
    loadAppointments();
  }, [loadAppointments]);

  const cancelAppointment = useCallback(async (id: string, comment: string, reasonId?: string) => {
    await appointmentService.cancelAppointment(id, comment, reasonId);
    await loadAppointments();
  }, [loadAppointments]);

  const confirmAppointment = useCallback(async (id: string) => {
    await appointmentService.confirmAppointment(id);
    await loadAppointments();
  }, [loadAppointments]);

  const now = new Date();

  const upcomingAppointments = appointments.filter(
    (apt) => apt.status === 'scheduled' && new Date(apt.date) >= now
  );

  const pastAppointments = appointments.filter(
    (apt) => apt.status !== 'scheduled' || new Date(apt.date) < now
  );

  return {
    appointments,
    upcomingAppointments,
    pastAppointments,
    isLoading,
    isMatched,
    error,
    refetch: loadAppointments,
    cancelAppointment,
    confirmAppointment,
  };
};
